import * as React from 'react';

import GamerTag from './GamerTag';

import { useApplication } from '../AppContext';

const PlayerTag = (props) => {
	const app = useApplication(); // Use the subscribing hook
    
	const playerInfo ={
		name: app.userdata?.name ?? '',
		level: app.userdata?.level ?? 1,
		avatar: app.userdata?.avatar ?? 'assets/Avatars/vv/AvatarVV_0071.png',
		achievementProgress: app.userdata?.achievementProgress ?? 0,
		inviteCode: app.userdata?.id ?? '',
		coins: app.userdata?.coins ?? 0,
	};// Force re-render when updateTrigger changes

	return (
		<GamerTag player={playerInfo} {...props} />
	);
};

export default PlayerTag;
